import React, { useContext, useEffect, useState, useCallback } from 'react';
import Checkbox from '@mui/material/Checkbox';

import ModalTemplate from '../../../common/ModalTemplate';
import { fetchIp, fetchTermsAndConditions, updateFtmTermsAndConditions } from '../../service';
import DivSpinner from '../../../common/DivSpinner';
import FormControlLabel from '@mui/material/FormControlLabel';
import { theme } from '../../../theme';
import { Context } from '../../Provider';
import toast from 'react-hot-toast';
import BtnSpinner from '../../../common/BtnSpinner';

const TermsAndConditions = ({ handleShowCompleted }) => {
    const [show, setShow] = useState(true);
    const [termsHtml, setTermsHtml] = useState('');
    const [loading, setLoading] = useState(true);
    const [ip, setIp] = useState(null);
    const [accepted, setAccepted] = useState(false);
    const [butLoading, setButLoading] = useState(false);

    const {
        state: { ftm },
    } = useContext(Context);

    const loadTermsAndConditions = useCallback(async () => {
        try {
            setLoading(true);
            const response = await fetchTermsAndConditions();
            if (response === 'Success' || response?.status === 'Success') {
                setTermsHtml(response.ftm_terms_and_conditions || '');
            } else {
                console.error('Failed to fetch terms and conditions.');
            }
        } catch (error) {
            console.error('Error fetching terms and conditions:', error);
        } finally {
            setLoading(false);
        }
    }, []);

    const loadIp = useCallback(async () => {
        try {
            const response = await fetchIp();
            if (response.status === 'Success') {
                setIp(response.ip);
            } else {
                console.error('Failed to fetch IP address.');
            }
        } catch (error) {
            console.error('Error fetching IP:', error);
        }
    }, []);

    useEffect(() => {
        loadTermsAndConditions();
        loadIp();
    }, [loadTermsAndConditions, loadIp]);

    const handleClose = () => setShow(false);

    const handleAccept = async () => {
        try {
            setButLoading(true);
            const response = await updateFtmTermsAndConditions(ftm?.ftm_id, ip);
            if (response.status === 'Success') {
                toast.success('Terms and conditions accepted successfully');
                setButLoading(false);
                handleClose();
                handleShowCompleted?.();
            } else {
                toast.error('Failed to accept terms and conditions');
            }
        } catch (error) {
            console.error('Error updating acceptance:', error);
            toast.error('An unexpected error occurred');
        }
    };

    const LoadingContent = () => (
        <div style={{ height: `${window.innerHeight - 387}px` }}>
            <DivSpinner />
        </div>
    );

    return (
        <ModalTemplate
            show={show}
            handleClose={handleClose}
            size="lg"
            centered
            title={null}
            backdrop="static"
            keyboard={false}
            body={
                loading ? (
                    <LoadingContent />
                ) : (
                    <>
                        <div
                            dangerouslySetInnerHTML={{ __html: termsHtml }}
                            style={{ maxHeight: '60vh', overflowY: 'auto', marginBottom: '1rem' }}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={accepted}
                                    onChange={(e) => setAccepted(e.target.checked)}
                                    color="success"
                                />
                            }
                            label="By proceeding to accept, you acknowledge and agree to the instafix terms and conditions."
                        />
                        <div className="text-end w-100">
                            <button
                                type="button"
                                className={`btn btn-${theme.main} btn-sm`}
                                disabled={!accepted || butLoading}
                                onClick={handleAccept}
                            >
                                {butLoading ? (
                                    <BtnSpinner />
                                ) : (
                                    'Accept'
                                )}
                            </button>
                        </div>
                    </>
                )
            }
            footer={null}
        />
    );
};

export default TermsAndConditions;